import axiosInstance from './axiosInstance';
import { ENDPOINTS } from './endpoints';

export const getProfileApi = () => axiosInstance.get(ENDPOINTS.PROFILE);
// Backend page=1&limit=10 bhejne par page galat (10) aur khali list de raha tha.
// Isliye page 1 par koi params nahi (default: page 1, limit 10), aage ke pages par sirf `page`.
export const getResultsApi = ({ page = 1 } = {}) =>
  axiosInstance.get(ENDPOINTS.RESULTS, { params: page > 1 ? { page } : undefined });
export const getMyBetsApi = (params) => axiosInstance.get(ENDPOINTS.MY_BETS, { params });
